<template>
  <div class="wrapper">
    <div class="elite-content_body_inner_header">
      <!--<div class="elite-content_body_inner_header_left">
        <svg
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.2445 4.90173H13.7356L11.7092 0.856341C11.6699 0.762112 11.6117 0.676989 11.5381 0.606291C11.4644 0.535592 11.377 0.480838 11.2813 0.445451C11.1855 0.410063 11.0835 0.394802 10.9816 0.400622C10.8797 0.406441 10.7801 0.433216 10.689 0.479273C10.5979 0.52533 10.5173 0.58968 10.4522 0.6683C10.3871 0.746921 10.3389 0.838122 10.3107 0.936205C10.2824 1.03429 10.2747 1.13715 10.288 1.23835C10.3013 1.33955 10.3353 1.43693 10.3879 1.52439L12.0729 4.90173H5.57058L7.25554 1.52439C7.32759 1.35137 7.33152 1.1575 7.26654 0.981701C7.20157 0.805905 7.07249 0.661196 6.90524 0.576628C6.73798 0.49206 6.54492 0.473894 6.36483 0.525777C6.18473 0.57766 6.03093 0.695751 5.9343 0.856341L3.90789 4.90173H1.39901C1.20215 4.90173 1.01335 4.97993 0.874145 5.11913C0.734942 5.25834 0.656738 5.44714 0.656738 5.644C0.656738 5.84086 0.734942 6.02966 0.874145 6.16887C1.01335 6.30807 1.20215 6.38627 1.39901 6.38627H1.45839L1.9186 11.8939C1.99694 12.8233 2.42227 13.689 3.10998 14.319C3.79769 14.9489 4.69736 15.2968 5.62997 15.2935H12.0432C12.9758 15.2968 13.8755 14.9489 14.5632 14.319C15.2509 13.689 15.6762 12.8233 15.7546 11.8939L16.1851 6.38627H16.2445C16.4413 6.38627 16.6301 6.30807 16.7693 6.16887C16.9085 6.02966 16.9867 5.84086 16.9867 5.644C16.9867 5.44714 16.9085 5.25834 16.7693 5.11913C16.6301 4.97993 16.4413 4.90173 16.2445 4.90173ZM14.2478 11.7677C14.2011 12.3256 13.9461 12.8454 13.5334 13.2237C13.1207 13.602 12.5807 13.8109 12.0209 13.809H5.61512C5.05532 13.8109 4.51532 13.602 4.10266 13.2237C3.69 12.8454 3.43495 12.3256 3.3883 11.7677L2.95036 6.38627H14.6931L14.2478 11.7677ZM11.0486 10.0976C11.0486 10.2945 10.9704 10.4833 10.8312 10.6225C10.6919 10.7617 10.5031 10.8399 10.3063 10.8399H9.56401V11.5822C9.56401 11.779 9.48581 11.9678 9.3466 12.107C9.2074 12.2463 9.0186 12.3245 8.82174 12.3245C8.62488 12.3245 8.43608 12.2463 8.29687 12.107C8.15767 11.9678 8.07947 11.779 8.07947 11.5822V10.8399H7.33719C7.14033 10.8399 6.95153 10.7617 6.81233 10.6225C6.67312 10.4833 6.59492 10.2945 6.59492 10.0976C6.59492 9.90077 6.67312 9.71197 6.81233 9.57277C6.95153 9.43357 7.14033 9.35536 7.33719 9.35536H8.07947V8.61309C8.07947 8.41623 8.15767 8.22743 8.29687 8.08822C8.43608 7.94902 8.62488 7.87082 8.82174 7.87082C9.0186 7.87082 9.2074 7.94902 9.3466 8.08822C9.48581 8.22743 9.56401 8.41623 9.56401 8.61309V9.35536H10.3063C10.5031 9.35536 10.6919 9.43357 10.8312 9.57277C10.9704 9.71197 11.0486 9.90077 11.0486 10.0976Z"
            fill="#000"
          />
        </svg>

        <h1>{{ $t("APPS.PURCHASES_MODULE") }}</h1>
      </div>
      <div class="elite-content_body_inner_header_right">
        <button><i class="far fa-ellipsis-h"></i></button>
      </div>-->
    </div>
    <div class="elite-content_body_inner_container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import moduleLayoutMixin from "@/mixins/module-layout-mixin";

export default {
  components: {},

  mixins: [moduleLayoutMixin],

  data() {
    return {};
  },

  methods: {},

  async mounted() {},

  computed: {},

  watch: {},
};
</script>
